import { ConfirmedEstimatedDateOfDeliveryBy } from "./ConfirmedEstimatedDateOfDeliveryBy";

class BritishColumbiaObstetricalFilePlannedPlaceOfBirth {
    public PlannedPlaceOfBirthAt20Weeks: string = "";
    public CopyToHospitalPlannedPlaceOfBirthAt20Weeks: boolean = false;
    public PlannedPlaceOfBirthAt36Weeks: string = "";
    public CopyToHospitalPlannedPlaceOfBirthAt36Weeks: boolean = false;
    public ReferralHospital: string = "";
    public ConfirmedEstimatedDateOfDelivery: Date = null;
    public ConfirmedEstimatedDateOfDeliveryBy?: ConfirmedEstimatedDateOfDeliveryBy = null;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFilePlannedPlaceOfBirth>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFilePlannedPlaceOfBirth };
